import { connect } from 'react-redux';
import ReportDialog from './report-dialog';

import { startPrintControlList, closeReportDialog } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  open: !!state.orders.openReportDialog,
  reports: state.orders.reports,
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeReportDialog()),
  printReport: (report, reportDate) => dispatch(startPrintControlList({
    report, reportDate
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportDialog);
